import { createSlice, PayloadAction } from '@reduxjs/toolkit';
import { Introduction } from '~/types';

export type IntroductionState = {
    introduction: Introduction,
};

const initialState: IntroductionState = {
    introduction: {
        title: '',
        content: '',
        video: ''
    }
};

export const introductionSlice = createSlice({
    name: 'introduction',
    initialState,
    reducers: {
        setIntroduction: (state, action: PayloadAction<IntroductionState>) => {
            state.introduction = action.payload.introduction;
        }
    }
});

export const { setIntroduction } = introductionSlice.actions;

export default introductionSlice.reducer;
